export const DEFAULT_BORDER_PADDING_FOR_PREVIEW_EMBED_AND_CLOSE_MODE = 6;